
import { OrgSdk } from 'lib-klab-sdks';
import { Location } from '../../../domain/models/organization/location.model';

export function mapSDKLocationToDomain(sdk: OrgSdk.LocationResponse): Location {
    return {
        id: sdk.locationId ?? 0,
        name: sdk.name ?? '',
        status: String(sdk.status ?? 'ACTIVE'),
        departments: (sdk.departments ?? []).map(d => ({
            id: d.departmentId ?? 0,
            name: d.name ?? '',
        })),
    };
}
